export const setRegisterUser = () => {
  sessionStorage.setItem('isUserRegister', true);
};

export const clearRegisterUser = () => {
  sessionStorage.removeItem('isUserRegister');
};

export const isUserRegister = () =>
  JSON.parse(sessionStorage.getItem('isUserRegister'));
